<template>
    <div class="mb-4 row" v-if="statuses != null && ordersByStatus != null">

        <div class="col-lg-12 col-md-12">
            <!--<transition name="fade">
                <div class="loading" v-show="loading">
                    <span class="fa fa-spinner fa-spin"></span> Loading
                </div>
            </transition>-->
            <div class="list-row" id="infinite-list">
                <template v-for="(orderByStatus, index) in ordersByStatus">
                    <div v-if="orderByStatus" class="customcolumn column"
                         :class="getStatusClass(orderByStatus.status)">
                        <div class="list-box">
                            <div class="inr-title" role="group">
                                <div class="d-flex">
                                    <div class="flex-grow-1">{{ orderByStatus.status.name }}</div>
                                    <div class="flex-shrink-0">
                                        <small class="badge bg-success align-bottom ms-1">
                                            {{orderByStatus.so_count}}
                                        </small>
                                    </div>
                                </div>
                            </div>
                            <div class="list-container" v-if="orderByStatus.salesOrders">
                                <draggable
                                    :id="'draggable_' + index"
                                    class="list-group"
                                    :list="ordersByStatus[index].salesOrders.data"
                                    draggable=".item"
                                    group="a"
                                    @change="handleChange($event, orderByStatus.status)"
                                >
                                    <div class="quote-list item"
                                         v-for="(item, itemIndex) in ordersByStatus[index].salesOrders.data"
                                         :id="item.id"
                                         :key="item.id"
                                         :class="{'mark-as-important': item.priority == 1}">
                                        <div class="white-bg quote-block">
                                            <div class="quote-header">
                                                <div class="quote-header-title">
                                                    <div class="q-nmbr">
                                                        <router-link :to="{ name: 'orderShow', params: { id: item.id }}"
                                                                     class="quote_view">
                                                            #{{ item.order_number }}
                                                        </router-link>
                                                        <span v-if="item.is_repeat_order" class="badge badge-soft-danger align-bottom ms-1">Repeat</span>
                                                        <span v-if="item.parent_id && !item.is_repeat_order" class="badge badge-soft-danger align-bottom ms-1">Clone</span>
                                                        <span v-if="item.labels && item.labels.length" class="badge badge-soft-danger align-bottom ms-1" :style="'color:' + label.color" v-for="(label, index) in item.labels">{{label.name}}</span>

                                                        <template v-if="item.purchase_orders && item.purchase_orders.filter((po) => po.labels.length).length">
                                                            <template v-for="(po, poIndex) in item.purchase_orders.filter((po) => po.labels.length)">
                                                                <span class="badge badge-soft-danger align-bottom ms-1" :style="'color:' + label.color" v-for="(label, index) in po.labels">{{label.name}}</span>
                                                            </template>
                                                        </template>
                                                    </div>

                                                </div>
                                                <!--<div class="quote-header-right" v-if="orderByStatus.status.id == 1">
                                                    <a @click="sendToCustomer(item)" class="btn-primary" href="javascript:void(0)">Send to Customer</a>
                                                </div>-->
                                                <div class="quote-header-right">
                                                    <template v-if="item.order_status">
                                                        <div class="cel-btn" :class="nameToCSSClass(item.order_status.name)" v-if="[10, 12].includes(item.order_status.id)">
                                                            <a class="btn-primary" href="javascript:void(0)">{{item.order_status.name}}</a>
                                                        </div>
                                                        <div class="cel-btn" :class="nameToCSSClass(item.order_status.name)" v-if="[4].includes(item.order_status.id)">
                                                            <a class="btn-primary" href="javascript:void(0)">{{item.order_status.name}}</a>
                                                        </div>
                                                    </template>
                                                    <div class="btn-group">
                                                        <a href="javascript:void(0);" class="text-muted dropdown-toggle" :id="'dropdownMenuLink1_'+item.id" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><i class="ri-more-fill"></i></a>
                                                        <ul class="dropdown-menu" :aria-labelledby="'dropdownMenuLink1_'+item.id">
                                                            <!--<li><a class="dropdown-item" href="javascript:void(0);" @click="goToView(item.id)"><i class="ri-eye-fill align-bottom me-2 text-muted"></i> View</a></li>
                                                            <li><a class="dropdown-item" href="javascript:void(0);" @click="goToView(item.id)"><i class="ri-edit-2-line align-bottom me-2 text-muted"></i> Edit</a></li>-->
                                                            <li v-if="item.priority != 1"><a class="dropdown-item" href="javascript:void(0);" @click="changePriority(item.id, 1)"><i class="ri-checkbox-circle-fill align-bottom me-2 text-muted"></i> Mark Important</a></li>
                                                            <li v-if="item.priority == 1"><a class="dropdown-item" href="javascript:void(0);" @click="changePriority(item.id, 0)"><i class="ri-checkbox-circle-fill align-bottom me-2 text-muted"></i> Un-mark Important</a></li>
                                                            <li><a class="dropdown-item"  href="javascript:void(0);" v-if="(getUser!= null && getUser.user_type == 1) || hasRole('Admin') || hasPerm('delete-sales-order')" @click="removeItem(item.id)"><i class="ri-delete-bin-5-line align-bottom me-2 text-muted"></i> Delete</a></li>
                                                        </ul>
                                                    </div>
                                                </div>

                                            </div>
                                            <div class="content-section">
                                                <div class="total-cost"><b>Total: </b>
                                                    <!--${{ getTotal(item.amount,item.charges,item.discounts) }}-->
                                                    ${{numberWithCommas(item.total_amount)}}

                                                </div>
                                                <div class="customer-name">
                                                    <b>Customer :</b>
                                                    <template v-if="item.customer">
                                                            <router-link :to="{name: 'customerDetails', params: {id: item.customer.id}}" target="_blank"
                                                                         title="Details Customer">
                                                        {{item.customer.company_name }}, ({{
                                                            item.customer.customer_contacts && item.customer.customer_contacts.length ? item.customer.customer_contacts[0].contact_name : ''
                                                        }})
                                                            </router-link>
                                                    </template>
                                                </div>
                                                <div class="user-name"><b>Added By: </b>
                                                    {{ item.added_by ? item.added_by.name : '' }}
                                                </div>
                                            </div>


                                        </div>
                                        <div class="quote-footer">
                                                <div class="d-flex">
                                                    <div class="flex-grow-1">
                                                        <small class="text-muted mb-0 fw-bold" :title="item.created_at_time">Created: <span :title="item.created_at_time">
                                                       {{ item.created_at_date }}
                                                    </span></small>
                                                    </div>
                                                    <div class="flex-shrink-0">
                                                        <small class="text-muted mb-0 fw-bold" :title="item.updated_at_time">Updated: <span :title="item.updated_at_time">
                                                        {{ item.updated_at_date }}
                                                    </span></small>
                                                    </div>
                                                </div>

                                            </div>
                                    </div>
                                </draggable>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
        </div>
        <!--<SendOrderToCustomer :order="order"></SendOrderToCustomer>-->
    </div>
</template>

<script>
import SendOrderToCustomer from "./SendOrderToCustomer";
import {mapState, mapActions, mapGetters} from 'vuex';
import axios from "axios";
import {debounce, merge} from 'lodash';
import OrdersByStatus from "./OrdersByStatus";
import draggable from 'vuedraggable';
import OrderGridItem from "./OrderGridItem";
import Vue from "vue";

export default {
    name: "OrderGrid",
    components: {OrdersByStatus, draggable, OrderGridItem,SendOrderToCustomer},
    props: ['search_filter', 'bus', 'filterData'],
    created() {
        this.getOrderStatuses();
    },
    beforeMount() {
        this.current_page = 1;
        this.loadedScrollAllPage = 0;
        this.ordersByStatus = [];
    },
    mounted() {
        let self = this;
        if (this.filterData) {
            this.filterForm = this.filterData;
        }
        this.getOrders(this);
        this.bus.$on('getOrders', () => {
            self.current_page = 1;
            self.getOrders(this);
        });
        /*const listElm = document.querySelector('#infinite-list');

        listElm.addEventListener('scroll', e => {
            if(listElm.scrollTop + listElm.clientHeight >= listElm.scrollHeight) {
                this.current_page += 1;
            }
        });*/
        window.onscroll = () => {
            let bottomOfWindow = document.documentElement.scrollTop + window.innerHeight === document.documentElement.offsetHeight;
            if (bottomOfWindow && this.loadedScrollAllPage == 0) {
                this.current_page += 1;
            }
        }
    },
    data() {
        return {
            order:null,
            orderData: null,
            total: 0,
            current_page: 1,
            loadedScrollAllPage: 0,
            filterForm: {
                search_filter: null,
                status_search: null,
                sale_user_id: null,
                search_customer_id: null,
                search_added_user_id: null,
                search_by_date: null,
                date_range: null,
                label_id: null
            },
            statuses: [],
            ordersByStatus: [],
            dragging: false
        }
    },
    methods: {
        ...mapActions([
            'setCommonErrors',
            'setErrorMessage',
            'setSuccessMessage',
            'setLoading'
        ]),
        goToView(id) {
            this.$router.push({name: 'orderShow', params: {id: id}});
        },
        changePriority(id, priority){
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.post(window.route('orders.changePriority', {id: id, priority: priority}), {}, {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    } else {
                        self.getOrders(self);
                        self.setSuccessMessage(data.message);
                        setTimeout(() => {
                            self.setSuccessMessage(null);
                        }, 5000);
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        removeItem(id){
            Vue.$confirm({
                title: 'Are you sure?',
                message: 'Are you sure you want to delete order?',
                button: {
                    yes: 'Yes',
                    no: 'Cancel'
                },
                callback: confirm => {
                    if(confirm) {
                        this.$emit('deleteItem', {id: id});
                    }

                }
            })
        },
        sendToCustomer(item){
            this.order = item;
            console.log("sendToCustomerModal",this.order);
            $('#sendToCustomerModal').modal('show');
        },
        getTotalExtraAmount(charges) {
            let total = 0;
            if (charges.length > 0) {
                charges.forEach((x) => {
                    total += x.amount * x.quantity;
                });
            }
            return total;
        },
        getDiscountAmount(amount,discounts) {
            if (discounts.length > 0) {
                if (discounts[0].isPercentage) {
                    return amount * discounts[0].amount / 100;
                } else {
                    return discounts[0].amount;
                }
            }
            return 0;
        },
        getTotal(amount,charges,discounts) {
            let total = amount + this.getTotalExtraAmount(charges) - this.getDiscountAmount(amount,charges);
            return total;
        },
        getStatusClass(status) {
            let index = this.statuses.findIndex((x) => x.id == status.id);
            if (index > -1) {
                return 'column' + (index + 1);
            }
            return "";
        },
        selectOrder(c) {
            this.$emit('selectOrder', c)
        },
        getOrdersByStatus(status) {
            return this.orderData ? this.orderData[status.name.toLowerCase().replace("/", "-").replace(/\s+/g, '-')] : null;
        },
        handleChange(event, status) {
            if(event.added && ((this.getUser!= null && this.getUser.user_type == 1) || this.hasRole('Admin'))) {
                //console.log('changed', event.added.element.id);
                //console.log('changed-st', status.id);
                let self = this;
                this.setLoading(true);
                this.setCommonErrors([]);
                this.setErrorMessage(null);
                return axios.put(window.route('orders.updateStatus', {id: event.added.element.id}), {status_id: status.id}, {
                    validateStatus: function (status) {
                        return status < 500; // Resolve only if the status code is less than 500
                    }
                })
                    .then(({data}) => {
                        if (data.errorMessage) {
                            self.setErrorMessage(data.errorMessage);
                            if (data.errors) {
                                self.setCommonErrors(data.errors);
                            }
                        } else {
                            self.setSuccessMessage(data.message);
                            self.getOrders(this);
                            setTimeout(() => {
                                self.setSuccessMessage(null);
                            }, 5000);
                        }
                    })
                    .catch((error) => {
                        self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                    })
                    .finally(() => {
                        self.setLoading(false);

                    });
            } else {
                this.getOrders(this);
            }
        },
        cloneOrder(id) {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.post(window.route('orders.clone', {id: id}), {}, {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    } else {
                        self.setSuccessMessage(data.message);
                        self.getOrders(this);
                        setTimeout(() => {
                            self.setSuccessMessage(null);
                        }, 5000);
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        getOrders: debounce((vm) => {
            let self = vm;//this;
            vm.setLoading(true);
            vm.setCommonErrors([]);
            vm.setErrorMessage(null);
            return axios.get(window.route('orders.index', {
                page: vm.current_page,
                search_filter: vm.filterForm.search_filter,
                status_search: vm.filterForm.status_search,
                sale_user_id: vm.filterForm.sale_user_id,
                search_customer_id: vm.filterForm.search_customer_id,
                search_added_user_id: vm.filterForm.search_added_user_id,
                search_by_date: vm.filterForm.search_by_date,
                date_range: vm.filterData.date_range,
                list_type: 'grid',
                label_id: vm.filterForm.label_id,
            }), {

                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errors && data.errors.length) {
                        self.setCommonErrors(data.errors);
                    } else if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        vm.orderData = data.data;
                        vm.total = data.data.total;
                        if(vm.current_page <= 1) {
                            vm.ordersByStatus = [];
                        }
                        let loadedScrollAllPage = 0;
                        vm.statuses.filter((x) => x.grid_active == 1).forEach((x, index) => {
                            let orderByStatus = vm.getOrdersByStatus(x);
                            if (orderByStatus) {
                                if(vm.current_page > 1 && vm.ordersByStatus[index]) {
                                    loadedScrollAllPage += orderByStatus.salesOrders.data.length;
                                    // vm.ordersByStatus[index].salesOrders.data = _.merge(_.keyBy(vm.ordersByStatus[index].salesOrders.data, 'id'), _.keyBy(orderByStatus.salesOrders.data, 'id'));
                                    vm.ordersByStatus[index].salesOrders.data = vm.ordersByStatus[index].salesOrders.data.concat(orderByStatus.salesOrders.data);
                                } else {
                                    vm.ordersByStatus.push(orderByStatus);
                                }

                            } else {
                                vm.ordersByStatus.push({
                                    salesOrders: {data: []},
                                    so_count: 0,
                                    status: x
                                });
                            }

                        });
                        if(vm.current_page > 1) {
                            vm.loadedScrollAllPage = loadedScrollAllPage == 0 ? 1 : 0;
                        }

                        vm.$emit('returnTotalNumOrders', data.data.total);
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        }, 350),
        getOrderStatuses() {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(window.route('sales-orders-status.index', {}), {

                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errors && data.errors.length) {
                        self.setCommonErrors(data.errors);
                    } else if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        this.statuses = data.data;
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
    },
    watch: {
        current_page: {
            handler: function (value) {
                if (value != 1) {
                    this.getOrders(this);
                }
            }
        },
        search_filter: {
            handler: function (value) {
                this.filterForm.search_filter = value;
            }
        },
        filterData: {
            handler: function (value) {
                this.filterForm = value;
            }
        },
    },
    computed: {
        ...mapState([
            'userState'
        ]),
        ...mapGetters([
            'isAuth',
            'getAuthUser',
            'commonErrors',
            'errorMessage',
            'successMessage',
            'loading'
        ])
    }
}
</script>

<style scoped>

</style>
